import type { AIStatus, Priority, RequestStatus } from './types'

export const STATUS_ORDER: RequestStatus[] = [
  'open',
  'in_progress',
  'ready_for_review',
  'approved',
  'needs_clarification',
  'completed',
]

export const STATUS_LABEL: Record<RequestStatus, string> = {
  open: 'Open',
  in_progress: 'In progress',
  needs_clarification: 'Needs clarification',
  ready_for_review: 'Ready for review',
  approved: 'Approved',
  completed: 'Completed',
}

/** Tailwind classes for status pills: tinted background, readable text, dot color. */
export const STATUS_STYLE: Record<RequestStatus, { pill: string; dot: string }> = {
  open: { pill: 'bg-sky-50 text-sky-800 ring-sky-200', dot: 'bg-sky-500' },
  in_progress: { pill: 'bg-amber-50 text-amber-800 ring-amber-200', dot: 'bg-amber-500' },
  needs_clarification: { pill: 'bg-violet-50 text-violet-800 ring-violet-200', dot: 'bg-violet-500' },
  ready_for_review: { pill: 'bg-accent-50 text-accent-800 ring-accent-200', dot: 'bg-accent-500' },
  approved: { pill: 'bg-emerald-50 text-emerald-800 ring-emerald-200', dot: 'bg-emerald-500' },
  completed: { pill: 'bg-ink-100 text-ink-700 ring-ink-200', dot: 'bg-ink-400' },
}

/** What clients see. No jargon. */
export const CLIENT_STATUS: Record<RequestStatus, { label: string; hint: string }> = {
  open: { label: 'Received', hint: 'Your request is with the team.' },
  in_progress: { label: 'In progress', hint: "We're working on this change." },
  needs_clarification: { label: 'We have a question', hint: 'Please answer so we can continue.' },
  ready_for_review: { label: 'Ready for your review', hint: 'Take a look and let us know if it looks right.' },
  approved: { label: 'Approved', hint: 'Thanks! We’ll publish it shortly.' },
  completed: { label: 'Done', hint: 'This change is complete.' },
}

export const PRIORITY_LABEL: Record<Priority, string> = {
  low: 'Low',
  normal: 'Normal',
  high: 'High',
  urgent: 'Urgent',
}

export const PRIORITY_STYLE: Record<Priority, string> = {
  low: 'text-ink-500',
  normal: 'text-ink-700',
  high: 'text-amber-700',
  urgent: 'text-red-700 font-semibold',
}

export const AI_LABEL: Record<AIStatus, string> = {
  pending: 'AI queued',
  processing: 'AI working…',
  completed: 'AI task ready',
  failed: 'AI failed',
  skipped: 'AI off',
}
